module.exports = __webpack_public_path__ + "logo-nexo-branco--ae065627.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/namidia/logo-nexo-branco.png
// module id = 199
// module chunks = 0